<footer class="mt-auto" id="dynamicFooterBg" style="background-size: cover; background-position: center">
  <div class="d-flex flex-wrap h-100 align-content-end align-items-baseline">
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-3">
      <p class="text-small"><em>This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" class="">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" class="">Terms of Service</a> apply.</em></p>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
      <mat-label class="fs-6 fst-italic">B: {{frontend_build_version}}</mat-label>
    </div>

    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-3" id="dynamicFooter">
    </div>
  </div>

</footer>
